<template>
    <svg aria-hidden="true" focusable="false" width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8 1L1 7L8 13" stroke="black" stroke-linecap="round" />
    </svg>
</template>
